import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from './services/auth.service';
import { Observable } from 'rxjs';
import { map, take, switchMap } from 'rxjs/operators';

export const noAuthGuard: CanActivateFn = (route, state): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isInitialized$.pipe(
    switchMap(() => authService.user$),
    take(1),
    map(user => {
      if (user) {
        const returnUrl = route.queryParams['returnUrl'] || '/dashboard';
        return router.parseUrl(returnUrl);
      }
      return true;
    })
  );
};
